import Extend from 'flarum/common/extenders';
import User from 'flarum/common/models/User';
export default [new Extend.Model(User).attribute('birthday').attribute('birthMonthDay').attribute('age').attribute('showBirthday').attribute('showAge').attribute('canEditBirthday')];